import {
  DisplayFormulario,
  TipoCampoFormulario,
} from 'src/app/compartido/formulario/utilidades/formulario.models';
import { ConfiguracionFormulario } from 'src/app/compartido/formulario/utilidades/formulario.models';

/* Configuración del formulario de orden */
export const CONFIGURACION_FORMULARIO_ORDEN: ConfiguracionFormulario = {
  campos: [
    {
      nombre: 'ID',
      slug: 'id',
      tipo: TipoCampoFormulario.NUMERO,
    },
    {
      nombre: 'N° Referencia',
      slug: 'referencia',
      tipo: TipoCampoFormulario.TEXTO,
    },
    {
      nombre: 'Tipo',
      slug: 'tipoDisplay',
      tipo: TipoCampoFormulario.TEXTO,
    },
    {
      nombre: 'Prioridad',
      slug: 'prioridadDisplay',
      tipo: TipoCampoFormulario.TEXTO,
    },
    {
      nombre: 'Estado',
      slug: 'estadoRealDisplay',
      tipo: TipoCampoFormulario.TEXTO,
    },
    {
      nombre: 'Fecha de Creación',
      slug: 'fechaCreacion',
      tipo: TipoCampoFormulario.FECHA,
    },
    {
      nombre: 'Punto de Origen',
      slug: 'origen',
      tipo: TipoCampoFormulario.TEXTO,
    },
    {
      nombre: 'Servicio',
      slug: 'servicio',
      tipo: TipoCampoFormulario.TEXTO,
    },
    {
      nombre: 'Recaudo',
      slug: 'recaudo',
      tipo: TipoCampoFormulario.TEXTO,
    },
    {
      nombre: 'Notas',
      slug: 'notas',
      tipo: TipoCampoFormulario.TEXTO,
    },
    {
      nombre: 'Orden Antecesora',
      slug: 'antecesora',
      tipo: TipoCampoFormulario.NUMERO,
    },
    {
      nombre: 'Orden Sucesora',
      slug: 'sucesora',
      tipo: TipoCampoFormulario.NUMERO,
    },
  ],
  estilo: {
    display: DisplayFormulario.GRID,
  },
};
